module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG0004-512efa642d852dd7f429db92dac5ce92.png";